import React from 'react';
import { Stack } from '@mui/material';
import withStyles from '@material-ui/core/styles/withStyles';
import { useTheme } from '@mui/material/styles';
import { VTypography } from '@venti-components';
import styles from './styles';
import ArtistCard from './ArtistCard/ArtistCard';

const Lineup = ({ classes, artists }) => {
  const theme = useTheme();
  if (!artists || artists.length === 0) return null;

  return (
    <Stack className={classes.container}>
      <Stack gap={0.75}>
        <VTypography align="left" variant="h3">
          Lineup
        </VTypography>
        <VTypography align="left" variant="body1" color={theme.palette.text.secondary}>
          Escuchá a los artistas del evento
        </VTypography>
      </Stack>
      <Stack direction="row" alignItems="flex-start" gap={1} className={classes.artistsContainer}>
        {artists.map((artist) => (
          <ArtistCard key={artist.id} artist={artist} />
        ))}
      </Stack>
    </Stack>
  );
};

export default withStyles(styles)(Lineup);
